<template>
<el-dialog class="coord-dashboard-fullscreen" :visible.sync="visible" :append-to-body="true" :show-close="false" fullscreen :modal="false" center @open="opened" @close="closed">
  <component :is="coordDashboardLayout" style="width: 100%; height: 100%;"/>
</el-dialog>
</template>

<script>
import DashboardConst from '@/constants/dashboard';

import WCoordDashboardLayout from '@/views/dashboard/components/frame/CoordDashboardLayout';

export default {
  name: 'WCoordDashboardFullscreenPopup',
  components: {
    WCoordDashboardLayout,
  },
  data() {
    return {
      visible: false,
      coordDashboardLayout: null,
    };
  },
  computed: {},
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN, this.open);
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN_CLOSE, this.close);
  },
  beforeDestroy() {
    this.close();
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN, this.open);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN_CLOSE, this.close);
  },
  methods: {
    /**
     * 전체화면 open 요청
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    open() {
      window.addEventListener('keyup', this.onConfirmClose);

      this.visible = true;
      this.$store.dispatch('openFullScreenLayer');

      this.$store.commit('setDashboardFullScreen', true);
      this.$nextTick(() => {
        this.coordDashboardLayout = WCoordDashboardLayout;
      });
    },
    /**
     * 전체화면 close 요청
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    close() {
      window.removeEventListener('keyup', this.onConfirmClose);

      this.visible = false;
      this.$store.dispatch('closeFullScreenLayer');

      this.coordDashboardLayout = null;
      this.$nextTick(() => {
        this.$store.commit('setDashboardFullScreen', false);
      });
    },
    /**
     * 전체화면 open 완료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    opened() {
      setTimeout(() => {
        this.$message('전체화면을 종료하려면 ESC를 누르십시오.');
      }, 100);
    },
    /**
     * 전체화면 close 완료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closed() {
    },
    onConfirmClose(evt) {
      if (this.visible && evt.keyCode === 27 && !this.conforming) {
        this.conforming = true;
        this.$confirm('전체화면을 종료하시겠습니까?', '확인', {
          confirmButtonText: '예',
          cancelButtonText: '아니오',
          confirmButtonClass: 'el-button--solid',
          closeOnPressEscape: false,
        })
          .then(() => {
            this.close();
          })
          .catch(() => {})
          .finally(() => {
            this.conforming = false;
          });
      }
    },
  },
};
</script>
<style lang="scss">
.coord-dashboard-fullscreen {
  .el-dialog {
    overflow: hidden;

    .el-dialog__header,
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__body {
      height: 100%;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/CoordDashboardFullscreenPopup.vue